import React from "react";
import PropTypes from "prop-types";

import "features/application/memberships/view.scss";

const MembershipsView = ({ userData, memberships, sendApiRequest }) => (
  <div className="form__content memberships__content">
    <h1 className="application__headline memberships__headline">
      Select membership approval process
    </h1>
    {userData &&
      memberships &&
      memberships.map(
        (membership) =>
          membership.is_visible && (
            <div className="memberships__membership" key={membership.id}>
              <h2 className="membership__headline">{membership.name}</h2>
              <p className="membership__price">
                {membership.currency
                  ? `${membership.currency.symbol}${membership.price} ${membership.interval}`
                  : "Free Preview"}
              </p>
              <p className="membership__information">
                {membership.currency &&
                  membership.price_information &&
                  membership.price_information}
              </p>
              <ul className="membership__list">
                {membership.is_premium && userData.member_amount && (
                  <li
                    className="membership__item membership__item-line-height"
                    style={{ fontWeight: 700 }}
                  >
                    Preferential Admission Process - <br />
                    currently {userData.member_amount} people on the waitlist
                  </li>
                )}
                {membership.description &&
                  membership.description.map((item, index) => (
                    <li className="membership__item" key={index}>
                      {item.element}
                    </li>
                  ))}
              </ul>
              <button
                className={`application__button membership__button`}
                type="button"
                data-membership={membership.id}
                data-isfree={membership.is_free}
                onClick={sendApiRequest}
              >
                Join
              </button>
            </div>
          )
      )}
  </div>
);

MembershipsView.propTypes = {
  userData: PropTypes.object,
  memberships: PropTypes.array,
  sendApiRequest: PropTypes.func,
};

export default MembershipsView;
